<template>
  <v-card>
    <v-card-title> {{ $t("Palauteasetukset") }} </v-card-title>

    <v-card-text>
      <v-tabs v-model="tab" outline>
        <v-tabs-slider></v-tabs-slider>
        <v-tab>{{ $t("Palauteilmoitukset") }}</v-tab>
        <v-tab>{{ $t("Palautteiden luokittelu") }}</v-tab>
        <v-tab>{{ $t("Palautteiden käsittelykäytäntö") }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <div class="pa-4 mt-4">
            <feedback-managers></feedback-managers>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="pa-4 mt-4">
            <feedback-categories></feedback-categories>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="pa-4 mt-4">
            <feedback-policy></feedback-policy>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import { useTranslations } from "@/@core/libs/i18n";
import feedbackPolicy from "./components/feedback_policy.vue";
import feedbackManagers from "./components/feedback_managers.vue";
import feedbackCategories from "./components/feedback_categories.vue";
import { useUrlQuery } from "@/composables/useUrlQuery";

export default {
  components: {
    feedbackPolicy,
    feedbackManagers,
    feedbackCategories
  },
  setup() {
    const tab = useUrlQuery("tab", 0);

    return {
      tab,
    };
  },
};
</script>

<style></style>